export const iconFontAwesomeArrowsCircleChevronDown = (
	<i className="fa-solid fa-circle-chevron-down"></i>
);
